<app-interview-sidebar>
  <div class="full-width copilot-page vertical">
    <div class="page-header">
      <div class="horizontal seperate bottom">
        <div class="page-title margin-top vertical">Interview</div>

        <button nz-button nzType="primary" nzSize="default" (click)="onNewInterviewClick()">
          <span nz-icon style="font-size: 16px" class="material-icons-outlined">add</span>
          Add Interview
        </button>
      </div>
    </div>

    <nz-alert nzType="info" nzMessage="Each interview lasts up to 60 minutes." nzShowIcon></nz-alert>

    <div class="basic-block">
      <nz-table #interviewTable [nzData]="interviewList()" [nzPaginationType]="'small'" [nzPageSize]="8">
        <thead>
          <tr>
            <th>Company</th>
            <th>Position</th>
            <th>Round</th>
            <th>Resume</th>
            <th [nzWidth]="'150px'">Type</th>
            <th [nzWidth]="'140px'">Create Time</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          @for (data of interviewTable.data; track data.id; let i = $index) {
            <tr>
              <td>{{ getGoal(data.subData.goalId)?.subData?.company ?? data.subData.goalCompany }}</td>
              <td>{{ getGoal(data.subData.goalId)?.subData?.position ?? data.subData.goalPosition }}</td>
              <td>{{ data.subData.interviewRound }}</td>
              <td>{{ getResume(data.subData.resumeId)?.title ?? data.subData.resumeTitle }}</td>
              <td>{{ getInterviewType(data.type) }}</td>
              <td>{{ data.createdTime | toLocaleFormat: 'ff' }}</td>
              <td>
                <div class="horizontal seperate">
                  @if (data.status === InterviewStatus.done) {
                    <nz-tag nzColor="success">
                      <span nz-icon nzType="check-circle"></span>
                      <span>Finished</span>
                    </nz-tag>
                  } @else if (isOngoing(data)) {
                    <div class="vertical">
                      <button nz-button nzType="primary" [nzSize]="'default'" (click)="onContinueInterviewClick(data)">
                        <span>Continue</span>
                      </button>
                      <div class="horizontal remaining-time">
                        <span nz-icon style="font-size: 16px" class="material-icons-outlined">timelapse</span>
                        <span>{{ getLeftMinutes(data) | number: '1.0-0' }} mins Left</span>
                      </div>
                    </div>
                  } @else {
                    <button
                      nz-button
                      nzType="primary"
                      [nzSize]="'default'"
                      [disabled]="hasOngoingInterview()"
                      [matTooltip]="
                        hasOngoingInterview()
                          ? 'You have an ongoing interview. Please complete or end it before starting a new one.'
                          : ''
                      "
                      (click)="onLaunchInterviewClick(data)"
                    >
                      Launch
                    </button>
                  }

                  <button
                    nz-button
                    nzType="text"
                    [nzDanger]="true"
                    [nzSize]="'small'"
                    [matTooltip]="'Remove'"
                    nz-popconfirm
                    nzOkText="Remove"
                    nzPopconfirmTitle="Are you sure you want to remove this interview?"
                    nzPopconfirmPlacement="bottom"
                    (nzOnConfirm)="onDeleteInterviewClick(data)"
                  >
                    <span nz-icon style="font-size: 16px" class="material-icons-outlined">delete_forever</span>
                  </button>
                </div>
              </td>
            </tr>
          }
        </tbody>
      </nz-table>
    </div>
  </div>
</app-interview-sidebar>

<app-new-interview-copilot
  [(isNewInterviewVisible)]="isNewInterviewVisible"
  [interviewType]="InterviewType.normal"
></app-new-interview-copilot>

<app-text-image-modal
  [(isVisible)]="isNotEnoughPointsVisible"
  title="Oops... You don't have enough points to launch an interview."
  content="Launching an interview will cost 10 points for a normal interview or 15 points for a coding interview."
  imageSrc="/assets/images/vector-illustrations/empty-box.png"
  okText="Get More Points"
  (okClick)="onGetMorePointsClick()"
  cancelText="Remind me next time"
></app-text-image-modal>

<app-text-image-modal
  [(isVisible)]="isFreeTrialVisible"
  title="Oops... You don't have enough points to launch an interview."
  content="You can start a 10-minute free trial once every 24 hours. Would you like to continue with a free trial?"
  imageSrc="/assets/images/vector-illustrations/empty-box.png"
  okText="Get More Points"
  (okClick)="onGetMorePointsClick()"
  cancelText="Start a 10-minute free trial"
  (cancelClick)="onFreeTrialClick()"
></app-text-image-modal>

<app-content-modal
  [isVisible]="showMobileModal()"
  [title]="'Please sign in using a desktop computer :)'"
  [content]="
    'Please use a desktop or laptop computer with the Google Chrome browser to access 360Interview AI for full feature availability.'
  "
  [okText]="'Got it'"
></app-content-modal>
